import { isNone } from '@ember/utils';

export const generateValidateRules = (model, attributes) => {
  let preprocessedAttributes = model.preprocessMeta.attributes;

  let mapAttributes = preprocessedAttributes.map(() => null);
  let skipAttributes = preprocessedAttributes.map(() => false);

  let ignoreRestrictedAttributes = [];

  attributes.forEach((attribute) => {
    let { key, to, skip, restricted, preprocessedIndex } = attribute.getProperties(
      'key',
      'to',
      'skip',
      'restricted',
      'preprocessedIndex',
    );

    // When we don't have a key and the attribute is skipped, that means it's a
    // reserved attribute that wasn't mapped. We don't have any other way of
    // storing that fact except storing it here.

    if (isNone(key)) {
      return skip ? ignoreRestrictedAttributes.addObject(to) : ignoreRestrictedAttributes.removeObject(to);
    }

    // Mapping and skipping otherwise is straightforward. Find
    // the index of the attribute and if there's a mapping,
    // change mapAttributes at that index.

    let index = preprocessedIndex;

    if (isNone(index)) {
      index = preprocessedAttributes.indexOf(key);
    }

    if (index >= 0) {
      // If the key is not the same as to, that means there's a mapping
      if (key !== to) {
        mapAttributes[index] = to;
      }

      // If there is a mapping for a restricted attribute but the attribute is
      // also skipped, we have a special case. We want to:
      //
      // (a) ensure that the mapping is removed.
      //
      // (b) add that attribute to our ignored list.

      if (skip && restricted && key !== to) {
        skipAttributes[index] = skip;
        mapAttributes[index] = null;
        ignoreRestrictedAttributes.addObject(to);
      } else {
        // Otherwise, just set the value of skip normally.
        skipAttributes[index] = skip;
      }
    }
  });

  return {
    ignoreRestrictedAttributes,
    skipAttributes,
    mapAttributes,
  };
};
